<template>
  <div :style="'overflow: hidden; position: relative; background: ' + Colors.Background + ';'+ (vertical?' width: 1px; min-height: 100%; max-height: 100%;':' width: auto; max-width: 100%; height: 1px;')"></div>
</template>

<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style>
</style>